import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, RouterModule } from '@angular/router';

import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { ParentRoutes } from './routes/app-routes';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ToastrModule } from 'ngx-toastr';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { EffectsModule } from '@ngrx/effects';
import { provideAnimations } from '@angular/platform-browser/animations';
import { ROOT_REDUCER } from './ngrx/app.state';
import { authorizeInterceptor } from './services/authorize.interceptor';
import { errorInterceptor } from './services/error-interceptor.service';
import { GarageEffects } from './ngrx/effects/garage.effects';

export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(
      ToastrModule.forRoot(),
      CommonModule,
      FormsModule,
      ReactiveFormsModule,
      RouterModule,
      StoreRouterConnectingModule.forRoot(),
      StoreModule.forRoot(ROOT_REDUCER, {
          runtimeChecks: {
              strictStateImmutability: false,
              strictActionImmutability: false
          }
      }),
      StoreDevtoolsModule.instrument({
          name: 'Angular Auth',
          maxAge: 25,
          logOnly: false
      }),
      EffectsModule.forRoot([GarageEffects]),
      MatFormFieldModule,
      MatInputModule,
      MatSnackBarModule,
      MatCheckboxModule,
      MatProgressSpinnerModule,
      NgbModule,
    ),
    provideHttpClient(withFetch(), withInterceptors([authorizeInterceptor, errorInterceptor])),
    provideZoneChangeDetection({ eventCoalescing: true }),
    // Single route registration — ParentRoutes is the full tree (a stale
    // inline duplicate used to be registered here as well).
    provideRouter(ParentRoutes),
    provideClientHydration(withEventReplay()),
    provideAnimations(),
  ]
};
